import R from 'ramda';

import { VenueDataFromAPI } from 'apis/restaurant-api/merchant-admin/venue/types';

import { VenueAvailabilityStatus as AvailabilityStatus, VenueRow, VenueAvailabilityStatus } from './types';

export const getVenueAvailabilityStatus = (venue: VenueDataFromAPI) => {
  if (!venue.public_visible) {
    return AvailabilityStatus.INACTIVE;
  }
  if (!venue.is_online) {
    return AvailabilityStatus.OFFLINE;
  }
  if (!venue.is_merchant_app_alive) {
    return AvailabilityStatus.IPAD_NOT_ALIVE;
  }
  if (!venue.is_open) {
    return AvailabilityStatus.CLOSED;
  }
  return AvailabilityStatus.AVAILABLE;
};

const byDescendingCreatedAt = (a: VenueDataFromAPI, b: VenueDataFromAPI) => b.created_at - a.created_at;

export const transformVenueDataFromAPI = (
  venues: VenueDataFromAPI[],
  showInactiveVenues?: boolean,
): {
  venueRowList: VenueRow[];
  availableCities: string[];
  containsInactiveVenues: boolean;
} => {
  const sortedVenues = venues.sort(byDescendingCreatedAt);
  const activeVenues = sortedVenues.filter(venue => venue.public_visible);
  const inactiveVenues = sortedVenues.filter(venue => !venue.public_visible);
  const newVenues = activeVenues;

  if (showInactiveVenues) {
    newVenues.push(...inactiveVenues);
  }

  return {
    availableCities: R.uniq(venues.map(venue => venue.city_name)),
    venueRowList: newVenues.map(venue => ({
      id: venue.venue_id,
      name: venue.venue_name,
      address: venue.venue_address,
      status: getVenueAvailabilityStatus(venue),
      merchantName: venue.merchant_name,
      contact: venue.phone,
      listImage: venue.listimage,
      cityName: venue.city_name,
    })),
    containsInactiveVenues: !!inactiveVenues.length,
  };
};

export const VENUE_STATUS_TOOLTIPS: { [key in VenueAvailabilityStatus]: string } = {
  [VenueAvailabilityStatus.AVAILABLE]: 'venue-availability-status.tooltip.venue-status.available',
  [VenueAvailabilityStatus.CLOSED]: 'venue-availability-status.tooltip.venue-status.closed',
  [VenueAvailabilityStatus.IPAD_NOT_ALIVE]: 'venue-availability-status.tooltip.venue-status.ipad-not-alive',
  [VenueAvailabilityStatus.OFFLINE]: 'venue-availability-status.tooltip.venue-status.offline',
  [VenueAvailabilityStatus.INACTIVE]: 'venue-availability-status.tooltip.venue-status.inactive',
};

export const VENUE_STATUS_TITLE: { [key in VenueAvailabilityStatus]: string } = {
  [VenueAvailabilityStatus.AVAILABLE]: 'venue-availability-status.table.status.available',
  [VenueAvailabilityStatus.CLOSED]: 'venue-availability-status.table.status.closed',
  [VenueAvailabilityStatus.IPAD_NOT_ALIVE]: 'venue-availability-status.table.status.ipad-not-alive',
  [VenueAvailabilityStatus.OFFLINE]: 'venue-availability-status.table.status.offline',
  [VenueAvailabilityStatus.INACTIVE]: 'venue-availability-status.table.status.inactive',
};
